export const DOCUMENT_CONFIGURATION = 'configurations';
export const DOCUMENT_CATEGORY = 'categories';
export const DOCUMENT_PRODUCT = 'products';
export const DOCUMENT_SECTION = 'sections';
export const DOCUMENT_SECTION_DETAIL = 'section_details';
export const DOCUMENT_COVER = 'covers';
export const DOCUMENT_LISTENER = 'listeners';

export const LISTENER_CONFIGURATIONS = 'configurations';
export const LISTENER_PRODUCTS = 'products';
export const LISTENER_SECTIONS = 'sections';
export const LISTENER_SECTION_DETAILS = 'section_details';
export const LISTENER_CATEGORIES = 'categories';
export const LISTENER_COVERS = 'covers';

export const CONFIGURATION_COMPANY = 'company';
export const CONFIGURATION_CATEGORY = 'category';